import React, { useEffect, useRef, useState } from "react";
import './Water-consumption.css';
import * as echarts from "echarts";
import chartConfig from "./charts.json";

const CHART_CONFIG = {
  tooltipDecimals: 3,
  yAxisDecimals: 0,
  yAxisPadding: 0.1,
  barWidth: '30%',
  lineColor: "#00ACEC",
};

const WaterConsumption = ({ data }) => {
  const chartRef = useRef(null);
  console.log("Water Consumption received chartData:", data);
  useEffect(() => {
    let chartInstance = echarts.init(chartRef.current);
    let resizeObserver;

    const option = {
      tooltip: {
        trigger: 'axis',
       appendToBody: true,
        confine: false,
        backgroundColor: 'white',
        borderColor: '#ccc',
        borderWidth: 1,
        extraCssText: 'z-index: 9999;',
        textStyle: { color: '#333', fontSize: 14 },
      },
      xAxis: {
        type: 'category',
        data: data.timestamp || [],
        name: 'Time',
        nameLocation: 'middle',
        nameGap: 25,
        axisLabel: { fontSize: 12, color: '#333', rotate: 0, interval: 'auto' },
        axisLine: { show: true, lineStyle: { color: '#333' } },
        axisTick: { show: true, alignWithLabel: true },
        splitLine: { show: false },
      },
      yAxis: {
        type: 'value',
        name: 'Consumption (Tsd.)',
        nameLocation: 'middle',
        nameGap: 50,
        nameTextStyle: { color: 'black', fontSize: 12 },
        axisLabel: { show: true, fontSize: 11, color: '#333' },
        axisLine: { show: true, lineStyle: { color: '#333' } },
        axisTick: { show: true },
        splitLine: { show: true, lineStyle: { type: 'dashed', color: '#ccc' } },
      },
      series: [
        {
          name: 'Water Consumption',
          type: 'bar',
          barWidth: CHART_CONFIG.barWidth,
          itemStyle: { color: CHART_CONFIG.lineColor },
          data: data.Wasser_Hauptzugang_G69927_2100001_13_Wasser_Durchflussmenge ? data.Wasser_Hauptzugang_G69927_2100001_13_Wasser_Durchflussmenge.map(item => item.value || 0) : [],
        },
      ],
      grid: {
        top: 30,
        left: chartRef.current?.offsetWidth < 500 ? 60 : '10%',
        right: chartRef.current?.offsetWidth < 500 ? 20 : '5%',
        bottom: '15%',
        containLabel: true
      },
    };

    chartInstance.setOption(option);

    // Add ResizeObserver for better responsiveness
    resizeObserver = new ResizeObserver(() => {
      if (chartInstance) {
        chartInstance.resize();
      }
    });

    resizeObserver.observe(chartRef.current);

    const handleResize = () => chartInstance.resize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
      chartInstance.dispose();
    };
  }, [data]);

  return (
    <div className="active-power-container">
      <div
        ref={chartRef}
        className="chart_activepower"
      />
    </div>
  );
};

export default WaterConsumption;